import React from 'react';
import BrandLogo from './BrandLogo';

/**
 * Welcome screen shown before the client starts the Annual Check-In.
 */
export default function StepWelcome({ clientName }) {
  return (
    <div className="cashflow-welcome text-center py-4">
      <BrandLogo size={72} className="mb-3" />
      <h2 className="h3 fw-bold mb-2">
        Welcome{clientName ? `, ${clientName.split(' ')[0]}` : ''}!
      </h2>
      <p className="text-muted mb-4" style={{ maxWidth: 560, margin: '0 auto' }}>
        This short Investment Management Update will help your advisor understand how you're
        feeling about your finances today. It should take about 5 minutes.
        Answer honestly — there are no wrong answers, and your responses
        simply guide the conversation at your next meeting.
      </p>
      <div className="row g-3 justify-content-center" style={{ maxWidth: 720, margin: '0 auto' }}>
        <div className="col-md-4">
          <div className="card h-100 shadow-sm border-0">
            <div className="card-body">
              <i className="bi bi-person-vcard fs-3 text-danger mb-2" />
              <h6 className="fw-semibold">Quick contact check</h6>
              <p className="small text-muted mb-0">Confirm how to reach you.</p>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card h-100 shadow-sm border-0">
            <div className="card-body">
              <i className="bi bi-stoplights fs-3 text-danger mb-2" />
              <h6 className="fw-semibold">Red / Yellow / Green</h6>
              <p className="small text-muted mb-0">Rate how you feel about a few key areas.</p>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card h-100 shadow-sm border-0">
            <div className="card-body">
              <i className="bi bi-graph-up fs-3 text-danger mb-2" />
              <h6 className="fw-semibold">Portfolio habits</h6>
              <p className="small text-muted mb-0">Tell us how often you check in.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
